import { render, staticRenderFns } from "./ProjectRoleUpdate.vue?vue&type=template&id=1623fdc6&"
import script from "./ProjectRoleUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectRoleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports